import { InitAddFileItem, InitAddVideoItem } from "tir-pm-file-upload-manager";
import { CommentChatMessageModel } from "./CommentChatMessageModel";
import { CommentFileModel } from "./CommentFileModel";

/**Модель описывает данные формы отправки комментария */
export class CommentFormDataModel {
  /**Редактируемый комментарий */
  EditedComment?: CommentChatMessageModel;
  /**Сообщение в комментарии */
  Message: string = "";
  /**Комментарий на который отвечаем */
  ReplyComment?: CommentChatMessageModel;
  /**ID папки куда грузить файлы */
  FileFolderId?: string;
  /**Загружаемый файл с устройства, который был прикреплен к комментарию */
  UploadingFile?: InitAddFileItem | InitAddVideoItem;
  /**Удаленный файл загруженный на сервер */
  RemoteFile?: CommentFileModel;
  /**Удалить файл при сохранении комментария */
  RemoveFileOnSave: boolean = false;

  constructor(obj?: Partial<CommentFormDataModel>) {
    Object.assign(this, obj);
  }
}
